import { Box, Button, CircularProgress, Grid, Paper, TextField, Tooltip } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus, numberWithCommas } from "../../../../utils";
import { PageLoader } from "../../../../shared_elements";
import { enqueueSnackbar } from "notistack";
import { getInsuranceClaimCardApi, updateInsuranceClaimCardApi } from "../apiService";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
const InsuranceClaimCardRU = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [insuranceClaimCardInfo, setInsuranceClaimCardInfo] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [prevData, setprevData] = useState([]); 

    useEffect(() => {
        getInsuranceClaimCardData();
        trackActivity('Page Viewed', { page_title: 'Insurance Config' })
    }, [])

    const getInsuranceClaimCardData = (loaderType, query = {}) => {
        setLoading(true);
        globalGetService(getInsuranceClaimCardApi(params)).then(response => {
            if (checkApiStatus(response)) {
                setInsuranceClaimCardInfo(response?.data?.data);
            }
            setLoading(false);
        })
    }
    const editInsuranceClaimCardData = () => {
        setLoading(true);
        globalPutService(updateInsuranceClaimCardApi(params), insuranceClaimCardInfo).then(response => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                trackActivity('Item Edited', { page_title: `Edit Insurance Config`, success_msg: response?.data?.message, item_id: insuranceClaimCardInfo?.id, payload: insuranceClaimCardInfo, response: response?.data })
                setEditMode(false);
            }
            setLoading(false);
        })
    }


    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Insurance Config`, page_type: page_type, })
    }
    return (
        <>
            <Paper
                elevation={1}
                sx={{
                    padding: 1,
                    margin: '10px 1px 8px 2px',
                    boxShadow: '0px 0px 2px 0.5px #BBBBBB',
                    // background:'#EAEAEA'

                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }} mt={2}>
                        <TextField
                            id="agreed_value"
                            value={!editMode && insuranceClaimCardInfo?.agreed_value ? numberWithCommas(insuranceClaimCardInfo?.agreed_value) : (insuranceClaimCardInfo?.agreed_value || '')}
                            label="Agreed Value as per the Lease Agreement"
                            variant="outlined"
                            onChange={(e) => setInsuranceClaimCardInfo(prev => ({ ...prev, agreed_value: e.target.value }))}
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            disabled={!editMode}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }} mt={2}>
                        <TextField
                            id="depreciation_per_year"
                            value={!editMode && insuranceClaimCardInfo?.depreciation_per_year ? numberWithCommas(insuranceClaimCardInfo?.depreciation_per_year) : (insuranceClaimCardInfo?.depreciation_per_year || '')}
                            label="Depreciation Per Year"
                            variant="outlined"
                            onChange={(e) => setInsuranceClaimCardInfo(prev => ({ ...prev, depreciation_per_year: e.target.value }))}
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            disabled={!editMode}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'end' }}>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['U'] }}>
                            {!editMode &&
                                <Tooltip title="Edit">
                                    <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }}
                                        onClick={() => { setEditMode(true); setprevData(insuranceClaimCardInfo); handleItemClicked('InsuranceClaim Card EditIcon') }} />
                                </Tooltip>}
                        </PermissionWrapper>
                        {editMode && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '6px' }}>
                                <Button className='cancel-btn' onClick={() => { setEditMode(false); setInsuranceClaimCardInfo(prevData); handleItemClicked('Cancel Button') }} sx={{ mr: 1 }} variant="outlined" size="small" disabled={isLoading}>
                                    Cancel
                                </Button>
                                <Button className='btn-primary' onClick={() => { handleItemClicked('Save Button'); editInsuranceClaimCardData(); }} variant="contained" size="small">
                                    {isLoading ? <CircularProgress color='inherit' size={24} /> : 'Save'}
                                </Button>
                            </Box>
                        )}
                    </Grid>
                    {editMode ?
                        <Grid size={{ md: 12, xs: 12 }} sx={{ backgroundColor: '#FFFFFF' }}>
                            <TextField
                                id="remarks"
                                value={insuranceClaimCardInfo?.remarks || ''}
                                label="Remarks"
                                variant="outlined"
                                onChange={(e) => setInsuranceClaimCardInfo(prev => ({ ...prev, remarks: e.target.value }))}
                                size="small"
                                margin="normal"
                                fullWidth
                                multiline
                                rows={3}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={!editMode}
                            />
                        </Grid>
                        : <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={insuranceClaimCardInfo?.remarks || ""} />
                        </Grid>}

                </Grid>
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default InsuranceClaimCardRU;